export default __webpack_public_path__ + "static/media/micro light.7efc873c.jpg";